import { actionHandler } from "../api";


const loginUrl = `/api/method/guidestar.api.user.login`;
const userLoginUrl = `/api/method/guidestar.api.user.data_user_login`;
const npoLoginUrl = `/api/method/guidestar.api.user.npo_login`;
const SearchNpoUrl = `api/method/guidestar.api.npo_registration.npo_registration_search`;
const ForgetPasswordUrl = `api/method/guidestar.api.user.forgot_password_request_otp`;
const verifyOTPUrl = `api/method/guidestar.api.user.verify_otp`;
const newPasswordUrl = `api/method/guidestar.api.user.set_new_password`;


// Data user login

export const login = async (payload) => {
    try {
        const { data } = await actionHandler({
            url: loginUrl,
            method: 'POST',
            data: payload,
        });
        if (data?.token) {
            const token = data.token
            localStorage.setItem("accessToken", token)
        }
        return data;
    } catch (error) {
        throw error;
    }
};


export const UserLogin = async (payload) => {
    try {
        const { data } = await actionHandler({
            url: userLoginUrl,
            method: 'POST',
            data: payload,
        });
        if (data?.token) {
            const token = data.token
            localStorage.setItem("dataUserAccessToken", token)
        }
        return data;
    } catch (error) {
        throw error;
    }
};
// npo user login

export const NpoLogin = async (payload) => {
    try {
        const { data } = await actionHandler({
            url: npoLoginUrl,
            method: 'POST',
            data: payload,
        });
        if (data?.token) {
            const token = data.token
            localStorage.setItem("NpoToken", token)
        }
        return data;
    } catch (error) {
        throw error;
    }
};
export const RegistrationNpoSearch = async ({ key, data }) => { // Destructure key and data from the argument

    try {
        const searchData = {
            pan: key === 'pan' ? data : '',
            darpan: key === 'darpan' ? data : '',
            organisation_name: key === 'name' ? data : '',
        };

        const args = encodeURIComponent(JSON.stringify(searchData));
        const response = await actionHandler({
            url: `${SearchNpoUrl}?args=${args}`,
            method: 'GET',
        });

        return response.data; // Return the data directly
    } catch (error) {
        throw error; // Ensure you handle errors appropriately
    }
};

export const NPOForgetPassword = async (payload) => {
    try {
        const { data } = await actionHandler({
            url: ForgetPasswordUrl,
            method: 'POST',
            data: payload,
        });
        return data;
    } catch (error) {
        throw error;
    }
};
export const NPOVerifyOTP = async (payload) => {
    try {
        const { data } = await actionHandler({
            url: verifyOTPUrl,
            method: 'POST',
            data: payload,
        });
        return data;
    } catch (error) {
        throw error;
    }
};
export const NPOResetPassword = async (payload) => {
    try {
        const { data } = await actionHandler({
            url: newPasswordUrl,
            method: 'POST',
            data: payload,
        });
        return data;
    } catch (error) {
        throw error;
    }
};









